export default __webpack_public_path__ + "static/media/ekldki.4e47b348.jpg";